import React from 'react'
import classNames from 'classnames'
import getDataForGraph from '@app/helpers/myEnergy/getDataForGraph'
import checkZeroDataForGraph from '@app/helpers/myEnergy/checkZeroDataForGraph'
import { intervalValues, Period } from '@app/lib/MyEnergy/intervalValues'
import { Paper, Typography } from '@mui/material'
// @ts-ignore — Slider is still untyped JS
import Slider from '@app/components/Common/Slider'
import { IEnergies } from '@app/@types/myEnergy'
import EnergyTotals from './EnergyTotals/EnergyTotals'
import SelectString from './SelectString/SelectString'
// @ts-ignore — Charts is still untyped JSX
import Chart from '../../../Charts/Charts'

interface Props {
  classes: Record<string, string>,
  periodSelector: Period,
  choosePeriod: (period: Period) => void,
  energies: IEnergies,
  selectedSliderTab: number,
  chooseSliderTab: (tab: number) => void,
  isMobile: boolean,
}

class EnergyTab extends React.Component<Props> {
  static displayName = 'EnergyTab'

  renderSelectString = (periodSelector: Period, choosePeriod: (period: Period) => void) => (
    <SelectString
      values={intervalValues}
      periodSelector={periodSelector}
      choosePeriod={choosePeriod}
    />
  )

  render() {
    const {
      classes,
      periodSelector,
      choosePeriod,
      energies,
      selectedSliderTab,
      chooseSliderTab,
      isMobile,
    } = this.props
    return (
      <Paper className={classNames(
        classes.root,
        (navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv'))
          && classes.webView,
      )}
      >
        {this.renderSelectString(periodSelector, choosePeriod)}
        <Slider
          firstComponent={checkZeroDataForGraph(periodSelector, energies, 'kwh') ? (
            <Typography className={classes.zeroData}>{I18n.t('my_energy.no_statistic_yet').toUpperCase()}</Typography>
          ) : (
            <Chart
              title="View kWh"
              xAxis={I18n.t('my_energy.period')}
              yAxis="kWh"
              data={getDataForGraph(periodSelector, energies, 'kwh')}
            />
          )}
          secondComponent={checkZeroDataForGraph(periodSelector, energies, 'dollar') ? (
            <Typography className={classes.zeroData}>{I18n.t('my_energy.no_statistic_yet').toUpperCase()}</Typography>
          ) : (
            <Chart
              title="View Dollars"
              xAxis={I18n.t('my_energy.period')}
              yAxis="dollar"
              data={getDataForGraph(periodSelector, energies, 'dollar')}
            />
          )}
          thirdComponent={<EnergyTotals energies={energies} periodSelector={periodSelector} isMobile={isMobile} />}
          selectedItem={selectedSliderTab}
          chooseSliderTab={chooseSliderTab}
        />
      </Paper>
    )
  }
}

export default EnergyTab
